import React from "react";

import { REACH_HERO_UNDERLINE } from "../../utils/reachMedia";

import "./IntensiveHeroDark.css";

const LOGO_SRC =
  "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive-english/nxtwave-intensive-logo.svg";

export default function IntensiveHeroDark() {
  return (
    <section className="intensive-hero-dark">
      <div
        data-animation="default"
        data-collapse="medium"
        data-duration="400"
        data-easing="ease"
        data-easing2="ease"
        role="banner"
        className="navbar intensive-hero-dark__nav w-nav"
      >
        <div className="container w-container">
          <a href="#top" className="brand-2 w-nav-brand">
            <img
              loading="lazy"
              src={LOGO_SRC}
              alt="NXT WAVE INTENSIVE logo"
              className="intensive-offline-logo"
            />
          </a>
        </div>
      </div>
      <div className="w-layout-blockcontainer intensive-container w-container">
        <div className="intensive-hero-dark__row">
          <div className="intensive-hero-dark__copy">
            <h1 className="intensive-hero-dark__heading">
              Have Questions Before You Join?
              <span className="intensive-hero-dark__heading-accent">
                Let&apos;s Clear your doubts
              </span>
            </h1>
            <img
              src={REACH_HERO_UNDERLINE}
              alt=""
              className="intensive-hero-dark__underline"
              aria-hidden="true"
            />
            <p className="intensive-hero-dark__subtext">
              Whether it&apos;s about placements, fees, the learning journey, or
              choosing the right program, we&apos;re here to help
            </p>
          </div>
          <div id="form-container" className="intensive-hero-dark__form form-container-cont">
            <div id="intensive-qualified" />
          </div>
        </div>
      </div>
    </section>
  );
}
